import api from './api';

const API_URL = '/trad';

class SetService {
  createSet(payload) {
    return api.post(API_URL + '/sets/', payload);
  }

  getSetList() {
    return api.get(API_URL + '/sets/');
  }

  getSetDetail(id) {
    return api.get(API_URL + '/sets/' + id + '/');
  }

  addSettingToSet(id, payload) {
    return api.post(API_URL + '/sets/' + id + '/add_setting/', payload);
  }

  setSettingOrder(id, payload) {
    return api.patch(API_URL + '/sets/' + id + '/set_order/', {
      set_setting_order: payload
    });
  }

  updateSetting(id, payload) {
    return api.patch(API_URL + '/settings/' + id + '/', payload);
  }

  deleteSetting(id) {
    return api.delete(API_URL + '/settings/' + id + '/')
  }

  getTuneList() {
    return api.get(API_URL + '/tunes/');
  }

  getUserProfile() {
    return api.get(API_URL + '/profiles/');
  }

  updateUserProfile(id, payload) {
    return api.patch(API_URL + '/profiles/' + id +'/', payload);
  }

  createRecording(payload) {
    return api.post(API_URL + '/recordings/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }});
  }

  getRecordingList() {
    return api.get(API_URL + '/recordings/');
  }

  updatePosition(id, payload) {
    return api.patch(API_URL + '/tune_positions/' + id +'/', payload);

  }

}

export default new SetService();
